// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-sidebar {
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  min-width: 220px;
}

.room-settings-sidebar-button {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  width: 100%;
}

.room-settings-sidebar-button ion-icon {
  font-size: 20px;
  color: #666;
}

.room-settings-sidebar-button:hover {
  background-color: #e8eaed;
}

.room-settings-sidebar-button.active {
  background-color: #d9d9d9;
  color: #000;
}

.room-settings-sidebar-button.active ion-icon {
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/SideBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".room-settings-sidebar {\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9fa;\n  border-right: 1px solid #e0e0e0;\n  min-width: 220px;\n}\n\n.room-settings-sidebar-button {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n  width: 100%;\n}\n\n.room-settings-sidebar-button ion-icon {\n  font-size: 20px;\n  color: #666;\n}\n\n.room-settings-sidebar-button:hover {\n  background-color: #e8eaed;\n}\n\n.room-settings-sidebar-button.active {\n  background-color: #d9d9d9;\n  color: #000;\n}\n\n.room-settings-sidebar-button.active ion-icon {\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
